export function updateSelection(alreadySelected, clickedId) {
  let updated = new Set(alreadySelected);
  if (!updated.delete(clickedId)) {
    updated.add(clickedId);
  }
  return updated;
}
